module.exports = __webpack_public_path__ + "static/media/2.f9f10178.png";